module.exports = __webpack_public_path__ + "static/media/info_active.5176a6d3.svg";